export default {
      id: "exit-full-screen-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "sprite.svg#exit-full-screen",
      toString: function () {
        return this.url;
      }
    }